export default `
mutation RequestResponse($propertyId: ID!, $senderName: String!, $senderId: ID!, $serviceProviderId: ID!) {
  requestResponse(propertyId: $propertyId, senderName: $senderName, senderId: $senderId, serviceProviderId: $serviceProviderId) {
    variant
    patrolWindows {
      minsToStart
      minsToEnd
      darsRequired
    }
    geofence
    place {
      coordinates {
        lat
        lng
      }
      formattedAddress
      addressComponents {
        city
        state
        county
        country
        zipCode
        subpremise
        streetName
        neighborhood
        streetNumber
        zipCodeSuffix
      }
      timezone
    }
    isDeleted
    adminNote
    createdAt
    updatedAt
    propertyId
    instanceId
    instancedAt
    displayName
    cardinal {
      time {
        start
        end
      }
      indefiniteStart
      note
      indefinite
    }
    serviceProviderId
    serviceProviderNote
  }
}
`;